<template>
  <nav>
    <h1>{{ title }}</h1>
    <button @click="$emit('logout')">Logout</button>
  </nav>
</template>

<script>
export default {
  name: 'NavigationBar',
  props: {
    title: {
      type: String,
      required: true
    }
  }
}
</script>